import styles from './HomePage.module.css';


function Home() {
    return <div className={styles.psevdoBody}>Тут скоро что-то появится</div>
}

export default Home;